// QUERIES__________________________
export const listDeployments = /* GraphQL */ `
  query ListDeployments (
    $projectId: Int!,
    $page: Int,
    $pageSize: Int,
    $sortDirection: String,
    $fileType: String,
    $deleted: Int!,
    $deployDescriptionKey: String,
    $deployDescriptionValue: String) {
    listDeployments(
      projectId: $projectId,
      page: $page,
      pageSize: $pageSize,
      sortDirection: $sortDirection,
      fileType: $fileType,
      deleted: $deleted,
      deployDescriptionKey: $deployDescriptionKey,
      deployDescriptionValue: $deployDescriptionValue
    ) {
      ... on ListDeploymentsSuccess {
        __typename
        data {
          deploymentID
          dateTime
          actor
          file {
            type
            fileID
            dateTime
            chunks
            content
            hashList
            hash
            manufacturerSignature
            softwareRequirements
            hardwareRequirements
            region
            metaData {
              major
              minor
              build
              hash
              version
              timestampToApply
              raw
            }
            assetDescription
          }
          target
          targetRegex
          targetMarket
          userCreation
          creationTimestamp
          exclude
          excludeMarket
          deleteTime
          deployDescription {
            userDescription
            userName
          }
          canaryMetadata {
            subsetType
            affectedSubset
            alreadySentTo
            numberOfCandidates
          }
          deployPaused
          deployReachable
        }
        pagination {
          totalRows
          isLast
          pageNumber
          pageRows
          pageSize
          totalPages
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const getDeployment = /* GraphQL */ `
  query GetDeployment ($projectId: Int!, $deploymentID: String!) {
    getDeployment(projectId: $projectId, deploymentID: $deploymentID) {
      ... on GetDeploymentSuccess {
        __typename
        result {
          deploymentID
          dateTime
          actor
          file {
            type
            fileID
            dateTime
            chunks
            content
            hashList
            hash
            manufacturerSignature
            softwareRequirements
            hardwareRequirements
            region
            metaData {
              major
              minor
              build
              hash
              version
              timestampToApply
              raw
            }
            assetDescription
          }
          target
          targetRegex
          targetMarket
          userCreation
          creationTimestamp
          exclude
          excludeMarket
          deleteTime
          deployDescription {
            userDescription
            userName
          }
          canaryMetadata {
            subsetType
            affectedSubset
            alreadySentTo
            numberOfCandidates
          }
          deployPaused
          deployReachable
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const getBundles = /* GraphQL */ `
  query GetBundles(
  $projectId: Int!,
  $sortDirection: String,
  $fileType: String,
  $page: String,
  $pageSize: String,
  $deleted: String,
  $releaseDescriptionValue: String,
  $releaseDescriptionKey: String
) {
  getBundles(
    projectId: $projectId,
    sortDirection: $sortDirection,
    fileType: $fileType,
    page: $page,
    pageSize: $pageSize,
    deleted: $deleted,
    releaseDescriptionValue: $releaseDescriptionValue,
    releaseDescriptionKey: $releaseDescriptionKey
  ) {
      ... on GetBundlesSuccess {
      __typename
        pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
        result {
          releaseDescription {
          description
        }
        title,
          fileIDs {
          assetDescription,
            fileID,
            dateTime,
            type,
          },
        region,
          brand,
          dateTime,
          releaseID
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getBundle = /* GraphQL */ `
  query GetBundle($projectId: Int!, $releaseID: String!) {
  getBundle(projectId: $projectId, releaseID: $releaseID) {
      ... on GetBundleSuccess {
      __typename
        result {
          releaseDescription {
          description
        }
        title,
          fileIDs {
          assetDescription,
            fileID,
            dateTime,
            type,
          },
        region,
          brand,
          dateTime,
          releaseID
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getBundleDeployments = /* GraphQL */ `
  query GetBundleDeployments($projectId: Int!, $releaseID: String!) {
  getBundleDeployments(projectId: $projectId, releaseID: $releaseID) {
      ... on GetBundleDeploymentsSuccess {
      __typename
        result {
        deployID
        dateTime
        actor
        file {
          type
          fileID
          dateTime
          chunks
          hashList
          hash
          softwareRequirements
          hardwareRequirements
          typeRequirements {
            hardwareRequirements
            softwareRequirements
            type
        }
          region
        }
        targetMarket
        target
        excludeMarket
          deployDescription {
          userDescription
          userName
        }
        releaseID
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getBundleFileTypes = /* GraphQL */ `
  query GetBundleFileTypes($projectId: Int!) {
  getBundleFileTypes(projectId: $projectId) {
      ... on GetBundleFileTypes {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getPermissions = /* GraphQL */ `
  query GetPermissions($projectId: Int!, $rawPermissions: String!) {
  getFrontendPermissions(projectId: $projectId, rawPermissions: $rawPermissions) {
      ... on GetFrontendPermissionsSuccess {
      __typename
      permissions
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }  
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getMachineTelemetryConsumptionCSV = /* GraphQL */ `
  query GetMachineTelemetryConsumptionCSV($projectId: Int!, $serialNumber: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $user: String!, $jwtToken: String!) {
  getMachineTelemetryConsumptionCSV(projectId: $projectId, serialNumber: $serialNumber, dateIni: $dateIni, dateEnd: $dateEnd, user: $user, jwtToken: $jwtToken) {
      ... on GetMachineTelemetryConsumptionCSVSuccess {
      __typename
      success
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getMachineTelemetryConsumption = /* GraphQL */ `
  query GetMachineTelemetryConsumption($projectId: Int!, $serialNumber: String!, $dateIni: AWSDateTime, $dateEnd: AWSDateTime, $limit: Int!, $offset: Int!) {
  getMachineTelemetryConsumption(projectId: $projectId, serialNumber: $serialNumber, dateIni: $dateIni, dateEnd: $dateEnd, limit: $limit, offset: $offset) {
      ... on GetMachineTelemetryConsumptionSuccess {
      __typename
        machineTelemetryConsumption {
        serialNumber
        market
        eventTimestamp
        serverTimestamp
        eventType
        code
        description
        type
        version
      }
        machineInfo {
        deviceFw
          extraDeviceFw {
          field
          value
        }
          modules {
          serial
          moduleFw
            extraDeviceFw {
            field
            value
          }
        }
        gatewayApp
      }
        pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getBrandConsumptions = /* GraphQL */ `
query GetBrandConsumptions($projectId: Int!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $limit: Int!, $offset: Int!, $searchByProcessedOnUtc: Boolean) {
  getBrandConsumptions(projectId: $projectId, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, limit: $limit, offset: $offset, searchByProcessedOnUtc: $searchByProcessedOnUtc) {
    ... on GetBrandConsumptionsSuccess {
      __typename
      brandConsumptions {
        id
        deviceSerial
        moduleSerial
        countryCode
        recipeCode
        productCode
        customerCode
        isValidTime
        extra
        createdOnLocal
        createdOnUtc
        receivedOnUtc
        processedOnUtc
        dictProduct{
          code
          market
          name
          insertedOn
          updatedOn
          isDeleted
        }
        dictRecipe{
          code
          market
          name
          extra
          insertedOn
          updatedOn
          isDeleted
        }
      }
      pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getBrandConsumptionsCSV = /* GraphQL */ `
query GetBrandConsumptionsCSV($projectId: Int!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $user: String!, $jwtToken: String!) {
  getBrandConsumptionsCSV(projectId: $projectId, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, user: $user, jwtToken: $jwtToken) {
    ... on GetBrandConsumptionsCSVSuccess {
      __typename
      success
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const listAssetsNotDeleted = /* GraphQL */ `
  query ListAssetsNotDeleted($projectId: Int!, $page: Int, $pageSize: Int, $sortDirection: String, $type: String, $assetDescriptionValue: String, $assetDescriptionKey: String) {
  listAssetsNotDeleted(projectId: $projectId, page: $page, pageSize: $pageSize, sortDirection: $sortDirection, type: $type, assetDescriptionValue: $assetDescriptionValue, assetDescriptionKey: $assetDescriptionKey) {
      ... on ListAssetsNotDeletedSuccess {
      __typename
        pagination {
        totalRows
        isLast
        pageNumber
        pageRows
        pageSize
        totalPages
      }
        data {
        chunks
        assetDescription
          metaData {
          build
          hash
          major
          minor
          raw
          timestampToApply
          version
        }
        metaDataStringified
        content
        creationTimestamp
        dateTime
        fileID
        hardwareRequirements
        hash
        hashList
        manufacturerSignature
        region
        softwareRequirements
        type
        typeRequirements {
          hardwareRequirements
          softwareRequirements
          type
        }
        userCreation
        releaseIDs
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getAsset = /* GraphQL */ `
  query GetAsset($projectId: Int!, $fileId: String!) {
  getAsset(projectId: $projectId, fileId: $fileId) {
      ... on GetAssetSuccess {
      __typename
        data {
        chunks
        assetDescription
        dateTime
          metaData {
          build
          hash
          major
          minor
          raw
          timestampToApply
          version
        }
        content
        creationTimestamp
        fileID
        hardwareRequirements
        hash
        hashList
        manufacturerSignature
        region
        softwareRequirements
        type
        typeRequirements {
          hardwareRequirements
          softwareRequirements
          type
        }
        userCreation
        releaseIDs
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getAssetTypes = /* GraphQL */ `
query getAssetTypes($projectId: Int!) {
  getAssetTypes(projectId: $projectId) {
    ... on GetAssetTypesSuccess {
      __typename
      response {
        data
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getDeploymentFileTypes = /* GraphQL */ `
query getAssetTypes($projectId: Int!) {
  getDeploymentFileTypes(projectId: $projectId) {
    ... on GetDeploymentFileTypesSuccess {
      __typename
      response {
        data
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getTelemetryObject = /* GraphQL */ `
query GetTelemetryObject($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $limit: Int!, $offset: Int!, $datesRange: Int!, $searchByProcessedOnUtc: Boolean) {
  getTelemetryObject(projectId: $projectId, object: $object, queryParams: $queryParams, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, limit: $limit, offset: $offset, datesRange: $datesRange, searchByProcessedOnUtc: $searchByProcessedOnUtc) {
    ... on GetTelemetryObjectSuccess {
      __typename
      data
      pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getTelemetryObjectCSV = /* GraphQL */ `
query GetTelemetryObjectCSV($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $datesRange: Int!, $user: String!, $jwtToken: String!) {
  getTelemetryObjectCSV(projectId: $projectId, object: $object, queryParams: $queryParams, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, datesRange: $datesRange, user: $user, jwtToken: $jwtToken) {
    ... on GetTelemetryObjectCSVSuccess {
      __typename
      success
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getLifeCycleObject = /* GraphQL */ `
query GetLifeCycleObject($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime, $paginationToken: String) {
  getLifeCycleObject(projectId: $projectId, object: $object, queryParams: $queryParams, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, paginationToken: $paginationToken) {
    ... on GetLifeCycleObjectSuccess {
      __typename
      data
      pagination {
        paginationContinuationToken
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getLifeCycleObjectPaginated = /* GraphQL */ `
query GetLifeCycleObject($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime, $page: Int, $pageSize: Int) {
  getLifeCycleObjectPaginated(
    projectId: $projectId, 
    object: $object, 
    queryParams: $queryParams, 
    filters: $filters, 
    dateIni: $dateIni, 
    dateEnd: $dateEnd, 
    page: $page, 
    pageSize: $pageSize
  ) {
    ... on GetLifeCycleObjectPaginatedSuccess {
      __typename
      data
      pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getLifeCycleObjectCSV = /* GraphQL */ `
query GetLifeCycleObjectCSV($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime, $datesRange: Int!, $user: String!, $jwtToken: String!) {
  getLifeCycleObjectCSV(
    projectId: $projectId, 
    object: $object, 
    queryParams: $queryParams, 
    filters: $filters, 
    dateIni: $dateIni, 
    dateEnd: $dateEnd, 
    datesRange: $datesRange, 
    user: $user, 
    jwtToken: $jwtToken) {
    ... on GetLifeCycleObjectCSVSuccess {
      __typename
      success
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getMachineCountKpis = /* GraphQL */ `
query GetMachineCountKpis(
  $projectId: Int!
  $deployId: String!
  $sync: String
  $page_size: Int
  $page: Int
  $groupBy: String
  $lastCheckForUpdate: String
) {
  getMachineCountKpis(
    projectId: $projectId
    deployId: $deployId
    sync: $sync
    page_size: $page_size
    page: $page
    groupBy: $groupBy
    lastCheckForUpdate: $lastCheckForUpdate
  ) {
    ... on GetMachineCountKpisSuccess {
      __typename
      result {
        projectCode
        deployId
        validData {
          toDo
          installed
          inProgress
          error
        }
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getMachineListKpis = /* GraphQL */ `
query GetMachineListKpis(
  $projectId: Int!
  $deployId: String!
  $sync: String
  $page_size: Int
  $page: Int
  $groupBy: String
  $lastCheckForUpdate: String
) {
  getMachineListKpis(
    projectId: $projectId
    deployId: $deployId
    sync: $sync
    page_size: $page_size
    page: $page
    groupBy: $groupBy
    lastCheckForUpdate: $lastCheckForUpdate
  ) {
    ... on GetMachineListKpisSuccess {
      __typename
      result {
        projectCode
        deployId
        validData {
          deployStatus
          deviceSerial
          updated_last_on
        }
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSRFfunctions = /* GraphQL */ `
query GetSRFfunctions($projectId: Int!) {
  getSRFfunctions(projectId: $projectId) {
    ... on GetSRFfunctionsSuccess {
      __typename
      result {
        functionUniqueName
        minSecure
        sourceId
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSRFBackends = /* GraphQL */ `
query GetSRFBackends($projectId: Int!) {
  getSRFBackends(projectId: $projectId) {
    ... on GetSRFBackendsSuccess {
      __typename
      result {
        algorithm
        brand
        sourceId
        privateKeyExists
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSRFToken = /* GraphQL */ `
query GetSRFToken($payload: String!, $algorithm: String!, $privateKey: String!) {
  getSRFToken(payload: $payload, algorithm: $algorithm, privateKey: $privateKey) {
    ... on GetSRFTokenSuccess {
      __typename
      result
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSandboxObject = /* GraphQL */ `
query GetSandboxObject($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $datesRange: Int!, $paginationToken: String) {
  getSandboxObject(projectId: $projectId, object: $object, queryParams: $queryParams, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, datesRange: $datesRange, paginationToken: $paginationToken) {
    ... on GetSandboxObjectSuccess {
      __typename
      data
      pagination {
        paginationContinuationToken
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSandboxObjectCSV = /* GraphQL */ `
query GetSandboxObjectCSV($projectId: Int!, $object: String!, $queryParams: String!, $filters: String!, $dateIni: AWSDateTime!, $dateEnd: AWSDateTime!, $datesRange: Int!, $user: String!, $jwtToken: String!) {
  getSandboxObjectCSV(projectId: $projectId, object: $object, queryParams: $queryParams, filters: $filters, dateIni: $dateIni, dateEnd: $dateEnd, datesRange: $datesRange, user: $user, jwtToken: $jwtToken) {
    ... on GetSandboxObjectCSVSuccess {
      __typename
      success
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getProjects = /* GraphQL */ `
  query GetProjects {
    getProjects {
      ... on GetProjectsSuccess {
      __typename
        projects {
        code
        id
        brandId
        permission
        name
        role
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getActionsBetweenDates = /* GraphQL */ `
query GetActionsBetweenDates($from: AWSDateTime!, $to: AWSDateTime!, $page: Int, $limit: Int!) {
  getActionsBetweenDates(from: $from, to: $to, page: $page, limit: $limit) {
    ... on GetActionsSuccess {
      __typename
      data {
        actionTimestamp
        id
        entityType
        entityId
        user
        actionType
        cognitoEmail
        actionDetails
      }
      pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getActionsBetweenDatesWithEmail = /* GraphQL */ `
query GetActionsBetweenDates($from: AWSDateTime!, $to: AWSDateTime!, $email: String!, $page: Int, $limit: Int!) {
  getActionsBetweenDates(from: $from, to: $to, email: $email, page: $page, limit: $limit) {
    ... on GetActionsSuccess {
      __typename
      data {
        actionTimestamp
        id
        entityType
        entityId
        user
        actionType
        actionDetails
        cognitoEmail
      }
      pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getActionStatistics = /* GraphQL */ `
query GetActionStatistics($from: AWSDateTime!, $to: AWSDateTime!, $projectId: Int) {
  getActionStatistics(from: $from, to: $to, projectId: $projectId) { 
    ... on GetActionStatisticsSuccess {
      __typename
      data
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getLastUsersAction = /* GraphQL */ `
query GetLastUsersAction {
  getLastUsersAction {
    ... on GetLastUsersActionSuccess {
      __typename
      result {
        user,
        lastAction,
        firstAction,
        cognitoEmail
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getCognitoUsersGroupsCSV = /* GraphQL */ `
  query GetCognitoUsersGroupsCSV {
    getCognitoUsersGroupsCSV {
      ... on GetCognitoUsersGroupsCSVSuccess {
      __typename
      csvData
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getNotifications = /* GraphQL */ `
  query GetNotifications($user: String!) {
  getNotifications(user: $user) {
      ... on NotificationsSuccess {
      __typename
        notifications {
        id
        title
        description
        type
        read
        timestamp
        user
        user_email
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getConfig = /* GraphQL */ `
  query GetConfig {
    getConfig {
      ... on GetConfigSuccess {
      __typename
      data
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getUnreadNotificationsCount = /* GraphQL */ `
  query GetUnreadNotificationsCount($user: String!) {
  getUnreadNotificationsCount(user: $user) {
      ... on UnreadNotificationsCountSuccess {
      __typename
      count
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getUnreadNotifications = /* GraphQL */ `
  query GetUnreadNotifications($projectId: Int!, $user: String!) {
  getUnreadNotifications(projectId: $projectId, user: $user) {
      ... on NotificationsSuccess {
      __typename
        notifications {
        id
        title
        description
        type
        read
        timestamp
        user
        user_email
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getDevicesPermissionsByProject = /* GraphQL */ `
  query GetDevicesPermissionsByProject($projectId: Int!) {
    getDevicesPermissionsByProject(projectId: $projectId) {
      ... on GetDevicesPermissionsByProjectSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getAnonymousQuickSightUrl = /* GraphQL */ `
  query GetAnonymousQuickSightUrl($namespace: String!, $dashboardId: String!, $projectsCode: String) {
    getAnonymousQuickSightUrl(namespace: $namespace, dashboardId: $dashboardId, projectsCode: $projectsCode) {
      ... on GetAnonymousQuickSightUrlSuccess {
        __typename
        url
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getUsersFromCognito = /* GraphQL */ `
query GetUsersFromCognito {
getUsersFromCognito {
    ... on GetUsersFromCognitoSuccess {
      __typename
      result {
        username
        email
        createdDate
        groups
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getCognitoUsersByEmail = /* GraphQL */ `
  query GetCognitoUsersByEmail($email: String!) {
    getCognitoUsersByEmail(email: $email) {
      ... on GetCognitoUsersByEmailSuccess {
        __typename
        result {
          username
          email
          createdDate
          groups
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getCognitoUsersFiltered = /* GraphQL */ `
  query GetCognitoUsersFiltered($searchText: String, $project: String, $role: String) {
    getCognitoUsersFiltered(searchText: $searchText, project: $project, role: $role) {
      ... on GetCognitoUsersFilteredSuccess {
        __typename
        result {
          username
          email
          createdDate
          groups
          lastLoginDate
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const checkGroupExists = /* GraphQL */ `
  query CheckGroupExists($groupName: String!) {
    checkGroupExists(groupName: $groupName) {
      ... on CheckGroupExistsSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getAuditLogs = /* GraphQL */ `
  query GetAuditLogs($limit: Int, $page: Int, $from: AWSDateTime, $to: AWSDateTime, $entity: String, $entity_id: String, $user_name: String) {
    getAuditLogs(limit: $limit, page: $page, from: $from, to: $to, entity: $entity, entity_id: $entity_id, user_name: $user_name) {
      ... on GetAuditLogsSuccess {
        __typename
        data {
          id
          entity
          entity_id
          change
          detail
          value
          user_id
          user_name
          action_timestamp
        }
        pagination {
          totalRows
          pageNumber
          pageSize
          pageRows
          totalPages
          isLast
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
    }
  }
`;

export const getPhysicalUsers = /* GraphQL */ `
  query GetPhysicalUsers{
    getPhysicalUsers {
      ... on GetPhysicalUsersSuccess {
        __typename
        result {
          id
          environment
          region
          userId
          logicalUser
          iAMUserName
          createdOn
          createdBy
          expirationDate
          latestRotation
          programmaticPointOfContact
          description
          logicalUserData {
            pointOfContact
            mailNotification
            brands
            projects {
              code
              name
            }
            iPWhiteList
          }
          quotaData {
            quota
            threshold
          }
          accessKeys {
            status
            accessKeyId
          }
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
      }
      ... on Forbidden {
        __typename
        message
      }
    }
  }
`;

export const getPhysicalUser = /* GraphQL */ `
  query GetPhysicalUser($physicalUserId: String!) {
    getPhysicalUser(physicalUserId: $physicalUserId) {
      ... on GetPhysicalUserSuccess {
        __typename
        result {
          id
          userId
          accessKeys {
            status
            accessKeyId
            lastUsedDate
          }
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
      }
      ... on Forbidden {
        __typename
        message
      }
    }
  }
`;
// MUTATIONS_________________________

export const uploadAssetsFromPackage = /* GraphQL */ `
  mutation UploadAssetsFromPackage($projectId: Int!, $filePath: String!) {
  uploadAssetsFromPackage
    (
      projectId: $projectId,
      filePath: $filePath,
    ) {
        ... on UploadAssetsFromPackageSuccess {
      __typename
          list{
        typeDescription
        fileID
        error
      }
    }
        ... on BadRequest {
      __typename
      message
      statusCode
    }
        ... on Forbidden {
      __typename
      message
      statusCode
    }
        ... on InternalServerError {
      __typename
      message
      statusCode
    }
        ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createSerialDeploy = /* GraphQL */ `
  mutation CreateSerialDeploy(
  $projectId: Int!,
  $fileIDS: [String],
  $releaseID: String,
  $type: String!,
  $value: [String],
  $comments: String,
  $deployRegEx: [String],
  $user: String,
  $CanaryStage: CanaryStage) {
  createSerialDeploy
    (
      projectId: $projectId,
      createDeploymentInput: {
      fileIDS: $fileIDS,
      releaseID: $releaseID,
      type: $type,
      value: $value,
      comments: $comments,
      deployRegEx: $deployRegEx,
      user: $user,
      CanaryStage: $CanaryStage,
    }
    ) {
        ... on DeploymentOutputSuccess {
      __typename
          deployResult {
        deployID
        waveId
        deployIDS
        newDeployIDs
        alreadyExistingDeployIDs
      }
    }
        ... on Forbidden {
      __typename
      message
      statusCode
    }          
        ... on BadRequest {
      __typename
      message
      statusCode
    }
        ... on InternalServerError {
      __typename
      message
      statusCode
    }
        ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createRegexDeploy = /* GraphQL */ `
  mutation CreateRegexDeploy(
  $projectId: Int!,
  $fileIDS: [String],
  $releaseID: String,
  $type: String!,
  $value: [String],
  $comments: String,
  $deployRegEx: [String],
  $user: String,
  $CanaryStage: CanaryStage) {
  createRegexDeploy
    (
      projectId: $projectId,
      createDeploymentInput: {
      fileIDS: $fileIDS,
      releaseID: $releaseID,
      type: $type,
      value: $value,
      comments: $comments,
      deployRegEx: $deployRegEx,
      user: $user,
      CanaryStage: $CanaryStage,
    }
    ) {
        ... on DeploymentOutputSuccess {
      __typename
          deployResult {
        deployID
        waveId
        deployIDS
        newDeployIDs
        alreadyExistingDeployIDs
      }
    }
        ... on Forbidden {
      __typename
      message
      statusCode
    }          
        ... on BadRequest {
      __typename
      message
      statusCode
    }
        ... on InternalServerError {
      __typename
      message
      statusCode
    }
        ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createMarketDeploy = /* GraphQL */ `
  mutation CreateMarketDeploy(
  $projectId: Int!,
  $fileIDS: [String],
  $releaseID: String,
  $type: String!,
  $value: [String],
  $comments: String,
  $deployRegEx: [String],
  $user: String,
  $CanaryStage: CanaryStage) {
  createMarketDeploy
    (
      projectId: $projectId,
      createDeploymentInput: {
      fileIDS: $fileIDS,
      releaseID: $releaseID,
      type: $type,
      value: $value,
      comments: $comments,
      deployRegEx: $deployRegEx,
      user: $user,
      CanaryStage: $CanaryStage,
    }
    ) {
        ... on DeploymentOutputSuccess {
      __typename
          deployResult {
        deployID
        waveId
        deployIDS
        newDeployIDs
        alreadyExistingDeployIDs
      }
    }
        ... on Forbidden {
      __typename
      message
      statusCode
    }          
        ... on BadRequest {
      __typename
      message
      statusCode
    }
        ... on InternalServerError {
      __typename
      message
      statusCode
    }
        ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createGlobalDeploy = /* GraphQL */ `
  mutation CreateGlobalDeploy(
  $projectId: Int!,
  $fileIDS: [String],
  $releaseID: String,
  $type: String!,
  $value: [String],
  $comments: String,
  $deployRegEx: [String],
  $user: String,
  $target: String,
  $targetMarket: String,
  $exclude: [String],
  $excludeMarket: [String],
  $CanaryStage: CanaryStage
) {
  createGlobalDeploy
    (
      projectId: $projectId,
      createDeploymentInput: {
      fileIDS: $fileIDS,
      releaseID: $releaseID,
      type: $type,
      value: $value,
      comments: $comments,
      deployRegEx: $deployRegEx,
      user: $user,
      target: $target,
      targetMarket: $targetMarket,
      exclude: $exclude,
      excludeMarket: $excludeMarket,
      CanaryStage: $CanaryStage
    }
    ) {
        ... on DeploymentOutputSuccess {
      __typename
          deployResult {
        deployID
        waveId
        deployIDS
        newDeployIDs
        alreadyExistingDeployIDs
      }
    }
        ... on Forbidden {
      __typename
      message
      statusCode
    }          
        ... on BadRequest {
      __typename
      message
      statusCode
    }
        ... on InternalServerError {
      __typename
      message
      statusCode
    }
        ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteDeploy = /* GraphQL */ `
  mutation DeleteDeploy($projectId: Int!, $deployId: String!) {
  deleteDeploy(
    projectId: $projectId,
    deployId: $deployId,
  ) {
          ... on DeleteDeploySuccess {
      __typename
      response
    }
          ... on Forbidden {
      __typename
      message
      statusCode
    }          
          ... on BadRequest {
      __typename
      message
      statusCode
    }
          ... on InternalServerError {
      __typename
      message
      statusCode
    }
          ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const updateDeployment = /* GraphQL */ `
  mutation UpdateDeployment($projectId: Int!, $deployId: String!, $requestBody: UpdateDeploymentInput!) {
  updateDeployment(
    projectId: $projectId,
    deployId: $deployId,
    requestBody: $requestBody
  ) {
          ... on UpdateDeploymentSuccess {
      __typename
      result {
        DeployID
        DeployIDS
      }
    }
          ... on Forbidden {
      __typename
      message
      statusCode
    }          
          ... on BadRequest {
      __typename
      message
      statusCode
    }
          ... on InternalServerError {
      __typename
      message
      statusCode
    }
          ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteBundle = /* GraphQL */ `
  mutation DeleteBundle($projectId: Int!, $releaseID: String!) {
  deleteBundle(
    projectId: $projectId, releaseID: $releaseID,
  ) {
      ... on DeleteBundleSuccess {
      __typename
      result
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }          
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteAsset = /* GraphQL */ `
mutation DeleteAsset($projectId: Int!, $deleteAssetInput: [DeleteAssetInput]!) {
  deleteAsset(
    projectId: $projectId,
    deleteAssetInput: $deleteAssetInput,
  ) {
      ... on DeleteAssetSuccess {
      __typename
        response {
        message
        statusCode
      }
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }          
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const updateAssetDescription = /* GraphQL */ `
  mutation UpdateAssetDescription($projectId: Int!, $fileId: String!, $assetDescription: String!) {
    updateAssetDescription(assetDescription: $assetDescription, fileId: $fileId, projectId: $projectId) {
      ... on UpdateAssetDescriptionSuccess {
        __typename
        response
      }
    }
}
`;

export const createNotification = /* GraphQL */ `
  mutation CreateNotification($title: String, $description: String, $user: String!, $type: String, $userEmail: String, $jwtToken: String) {
    createNotification(title: $title, description: $description, user: $user, type: $type, userEmail: $userEmail, jwtToken: $jwtToken) {
      ... on NotificationSuccess {
        __typename
          notification {
          id
          title
          description
          type
          read
          timestamp
          user
          user_email
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
}
`;

export const markAsReadMutation = /* GraphQL */ `
  mutation MarkAsRead($id: String!) {
    markAsRead(id: $id) {
      ... on MarkNotificationSuccess {
        __typename
        response
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
}
`;

export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification($id: String!) {
    deleteNotification(id: $id) {
      ... on DeleteNotificationSuccess {
        __typename
        response
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
}
`;

export const deleteCognitoUserByUserId = /* GraphQL */ `
  mutation DeleteCognitoUserByUserId($userId: String!) {
    deleteCognitoUserByUserId(userId: $userId) {
      ... on DeleteCognitoUserByUserIdSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const deleteMyAccount = /* GraphQL */ `
  mutation DeleteMyAccount {
    deleteMyAccount {
      ... on DeleteMyAccountSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const addGroupToUser = /* GraphQL */ `
  mutation AddGroupToUser($userId: String!, $group: String!) {
    addGroupToUser(userId: $userId, group: $group) {
      ... on AddGroupToUserSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const removeGroupFromUser = /* GraphQL */ `
  mutation RemoveGroupFromUser($userId: String!, $group: String!) {
    removeGroupFromUser(userId: $userId, group: $group) {
      ... on RemoveGroupFromUserSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const createCognitoUser = /* GraphQL */ `
  mutation CreateCognitoUser($email: String!, $password: String!) {
    createCognitoUser(email: $email, password: $password) {
      ... on CreateCognitoUserSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const createCognitoGroup = `
  mutation CreateCognitoGroup($groupName: String!) {
    createCognitoGroup(groupName: $groupName) {
      ... on CreateCognitoGroupSuccess {
        __typename
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const UPDATE_USER_LAST_LOGIN_DATE = `
  mutation updateUserLastLoginDate($username: String!) {
    updateUserLastLoginDate(username: $username) {
      __typename
      ... on UpdateUserLastLoginDateSuccess {
        result
      }
      ... on BadRequest {
        message
        statusCode
      }
      ... on InternalServerError {
        message
        statusCode
      }
      ... on Forbidden {
        message
        statusCode
      }
    }
  }
`;

export const onNewNotificationItem = /* GraphQL */ `
  subscription OnNewNotificationItem {
    onNewNotificationItem {
      ... on NotificationSuccess {
      __typename
        notification {
        description
        id
        read
        timestamp
        title
        type
        user
        user_email
      }
    }
      ... on BadRequest {
      __typename
      statusCode
      message
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const onUpdateConfig = /* GraphQL */ `
  subscription OnUpdateConfig {
    onUpdateConfig {
      ... on UpdateConfigSuccess {
      __typename
      success
    }
      ... on BadRequest {
      __typename
      statusCode
      message
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const updateConfig = /* GraphQL */ `
  mutation UpdateConfig($config: String!) {
  updateConfig(config: $config) {
      ... on UpdateConfigSuccess {
      __typename
      success
    }
      ... on BadRequest {
      __typename
      statusCode
      message
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createBundle = /* GraphQL */ `
  mutation CreateBundle($projectId: Int!, $release: NewBundle!) {
  createBundle(projectId: $projectId, release: $release) {
      ... on CreateBundleSuccess {
      __typename
      result {
        releaseID
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const updateBundle = /* GraphQL */ `
  mutation UpdateBundle($projectId: Int!, $releaseID: String!, $title: String!, $description: String!) {
    updateBundle(projectId: $projectId, releaseID: $releaseID, title: $title, description: $description) {
      ... on UpdateBundleSuccess {
        __typename
        result # Boolean field, no subselection allowed
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const executeSRF = /* GraphQL */ `
  mutation ExecuteSRF($projectId: Int!, $machineId: String!, $functionName: String!, $securityMode: String!, $jwtToken: String!) {
  executeSRF(projectId: $projectId, machineId: $machineId, functionName: $functionName, securityMode: $securityMode, jwtToken: $jwtToken) {
      ... on ExecuteSRFSuccess {
      __typename
      result {
        payload {
          reqId
          status
          exp
          sub
          aud
          iat
        }
        encodedToken
        header
      }

    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const cancelSRF = /* GraphQL */ `
  mutation CancelSRF($projectId: Int!, $reqId: String!) {
  cancelSRF(projectId: $projectId, reqId: $reqId) {
      ... on CancelSRFSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getSRFRequest = /* GraphQL */ `
  query GetSRFRequest($projectId: Int!, $reqId: String!) {
  getSRFRequest(projectId: $projectId, reqId: $reqId) {
    ... on GetSRFRequestSuccess {
      __typename
      result {
        payload {
          reqId
          status
          exp
          sub
          aud
          iat
          lastChange
          iss
          results {
            res
            now
          }
        }
        encodedToken
        header
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getSRFRequests = /* GraphQL */ `
  query GetSRFRequests($projectId: Int!, $machineId: String!) {
  getSRFRequests(projectId: $projectId, machineId: $machineId) {
    ... on GetSRFRequestsSuccess {
      __typename
      result {
        expiration
        functionId
        functionName
        lastChange
        retry
        secure
        sourceId
        status
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getCertificateQuota = /* GraphQL */ `
  query GetCertificateQuota($awsUserId: String!) {
  getCertificateQuota(awsUserId: $awsUserId) {
    ... on GetCertificateQuotaSuccess {
      __typename
      result {
        quota
        restrictedUser
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const getCertificateStatus = /* GraphQL */ `
  query GetCertificateStatus($certificateId: String!) {
  getCertificateStatus(certificateId: $certificateId) {
    ... on GetCertificateStatusSuccess {
      __typename
      result {
        certificateID
        certificateARN
        caCertificateID
        status
        policies {
          policyName
          policyArn
        }
        onboardingStatus
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const deleteNotificationsByTitle = /* GraphQL */ `
  mutation DeleteNotificationsByTitle($title: String!) {
  deleteNotificationsByTitle(title: $title) {
    ... on DeleteNotificationSuccess {
      __typename
      response
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteWave = /* GraphQL */ `
  mutation DeleteWave($projectId: Int!, $waveID: String!) {
  deleteWave(projectId: $projectId, waveID: $waveID) {
      ... on DeleteWaveSuccess {
      __typename
        result {
        deletedDeployIDs
        maintainedDeployIDs
        deletedWaveID
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const updateWave = /* GraphQL */ `
  mutation UpdateWaveObject($projectId: Int!, $waveID: String!, $waveDescription: String, $wavePaused: Boolean, $canaryStage: UpdateWaveCanaryStageInput) {
  updateWaveObject(projectId: $projectId, waveID: $waveID, waveDescription: $waveDescription, wavePaused: $wavePaused, canaryStage: $canaryStage) {
      ... on UpdateWaveSuccess {
      __typename
        result {
          wavePaused
          waveDescription
          canaryStage {
            Absolute
            Relative
            Full
          }
        
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const listPaginatedWaves = /* GraphQL */ `
  query ListPaginatedWaves(
  $projectId: Int!,
  $page: Int,
  $pageSize: Int,
  $sortDirection: String,
  $datetimeFrom: String,
  $datetimeTo: String,
  $waveDescriptionKey: String,
  $waveDescriptionValue: String,
  $fileType: String,
  $fileID: String,
  $releaseID: String,
  $deployID: String
) {
  listPaginatedWaves(
    projectId: $projectId,
    page: $page,
    pageSize: $pageSize,
    sortDirection: $sortDirection,
    datetimeFrom: $datetimeFrom,
    datetimeTo: $datetimeTo,
    waveDescriptionKey: $waveDescriptionKey,
    waveDescriptionValue: $waveDescriptionValue,
    fileType: $fileType,
    fileID: $fileID,
    releaseID: $releaseID,
    deployID: $deployID
  ) {
      ... on ListPaginatedWavesSuccess {
      __typename
        data {
        brand
        waveID
        dateTime
        targetMarket
        excludeMarket
        target
        targetRegex
        excludeRegex
        wavePaused
          waveDescription {
          userDescription
        }
        canaryMetadata {
          subsetType
          affectedSubset
          alreadySentTo
          numberOfCandidates
        }
        releaseId
        deployIDs
        release {
          releaseDescription {
            description
          }
          title
          region
          fileIDs {
            type
            fileID
            dateTime
            chunks
            manufacturerSignature
            softwareRequirements
            hardwareRequirements
            region
          }
          brand
          dateTime
          releaseID
        }
        deploys {
          deployID
          dateTime
          actor
          file {
            type
            fileID
            dateTime
            chunks
            assetDescription {
              version
              description
            }
          }
          deployDescription {
            userDescription
            userName
          }
          deployReachable
        }
      }
        pagination {
        totalRows
        pageNumber
        pageSize
        pageRows
        totalPages
        isLast
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getWaveById = /* GraphQL */ `
  query GetWaveById($projectId: Int!, $waveID: String!) {
  getWaveById(projectId: $projectId, waveID: $waveID) {
      ... on GetWaveByIdSuccess {
      __typename
        result {
        waveID
        dateTime
        targetMarket
        excludeMarket
        target
        targetRegex
        excludeRegex
        wavePaused
          waveDescription {
          userDescription
        }
          canaryMetadata {
            subsetType
            affectedSubset
            alreadySentTo
            numberOfCandidates
          }
          release {
            releaseDescription {
            description
          }
          title
          region
            fileIDs {
            type
            fileID
            dateTime
            chunks
            manufacturerSignature
            softwareRequirements
            hardwareRequirements
            region
          }
          brand
          dateTime
          releaseID
        }
          deploys {
          deployID
          dateTime
          actor
            file {
            type
            fileID
            dateTime
            chunks
              assetDescription {
              version
              description
            }
          }
            deployDescription {
            userDescription
            userName
          }
        }
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const onboardingDevice = /* GraphQL */ `
  mutation OnBoardingDevice($projectId: Int!, $serialNumber: String!, $topicNumber: Int!,$payload: String!) {
  onboardingDevice(
    projectId: $projectId, 
    serialNumber: $serialNumber, 
    topicNumber: $topicNumber,
    payload: $payload) {
      ... on OnboardingDeviceSuccess {
      __typename
        result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getIotMessages = /* GraphQL */ `
  query GetIotMessages($projectId: Int!, $serialNumber: String!, $topicNumber: Int!) {
  getIotMessages(projectId: $projectId, serialNumber: $serialNumber, topicNumber: $topicNumber) {
      ... on GetIotMessagesSuccess {
      __typename
        result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const subscribeToTopic = /* GraphQL */ `
  mutation SubscribeToTopic($projectId: Int!, $serialNumber: String!, $topicNumber: Int!) {
  subscribeToTopic(projectId: $projectId, serialNumber: $serialNumber, topicNumber: $topicNumber) {
      ... on SubscribeToTopicSuccess {
      __typename
        result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;


export const getDeviceConnectivityStatus = /* GraphQL */ `
  query GetDeviceConnectivityStatus($projectId: Int!, $serialNumber: String!) {
    getDeviceConnectivityStatus(projectId: $projectId, serialNumber: $serialNumber) {
      ... on GetDeviceConnectivityStatusSuccess {    
        __typename
        result {
          connected
          lastUpdate
          disconnectReason
          brand
          machineID
          principalID
        }
      }
      ... on BadRequest {
        message
        statusCode
      }
      ... on Forbidden {
        message
        statusCode
      }
      ... on InternalServerError {
        message
        statusCode
      }
      ... on NotFound {
        message
        statusCode
      }
    }
  }
`;

export const getDeviceConnectivityStatusHistory = /* GraphQL */ `
query GetDeviceConnectivityStatusHistory($projectId: Int!, $serialNumber: String, $from: String, $to: String, $paginationToken: String) {
  getDeviceConnectivityStatusHistory(projectId: $projectId, serialNumber: $serialNumber, from: $from, to: $to, paginationToken: $paginationToken) {
    ... on GetDeviceConnectivityStatusHistorySuccess {
      __typename
      result {
        serial
        from
        to
        events {
          deviceSerial
          type
          reason
          updateAt
          principalID
        }
        page
        nextToken
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getDeviceHistory = /* GraphQL */ `
query GetDeviceHistory(
  $projectId: Int!
  $serialNumber: String!
  $from: AWSDateTime!
  $to: AWSDateTime!
  $limit: Int!
  $pageNumber: Int
) {
  getDeviceHistory(
    projectId: $projectId
    serialNumber: $serialNumber
    from: $from
    to: $to
    limit: $limit
    pageNumber: $pageNumber
  ) {
    ... on GetDeviceHistorySuccess {
      __typename
      result {
        items { id serial model country_code fw hw sdk extra timezone received_on_utc processed_on_utc }
        pageNumber pageSize totalRows totalPages isLast
      }
    }
    ... on BadRequest { __typename message statusCode }
    ... on Forbidden { __typename message statusCode }
    ... on InternalServerError { __typename message statusCode }
    ... on NotFound { __typename message statusCode }
  }
}
`;

export const getGatewayHistory = /* GraphQL */ `
query GetGatewayHistory(
  $projectId: Int!
  $serialNumber: String!
  $gatewaySerial: String!
  $from: AWSDateTime!
  $to: AWSDateTime!
  $limit: Int!
  $pageNumber: Int
) {
  getGatewayHistory(
    projectId: $projectId
    serialNumber: $serialNumber
    gatewaySerial: $gatewaySerial
    from: $from
    to: $to
    limit: $limit
    pageNumber: $pageNumber
  ) {
    ... on GetGatewayHistorySuccess {
      __typename
      result {
        items { id serial model version device_serial sdk app msl extra received_on_utc processed_on_utc }
        pageNumber pageSize totalRows totalPages isLast
      }
    }
    ... on BadRequest { __typename message statusCode }
    ... on Forbidden { __typename message statusCode }
    ... on InternalServerError { __typename message statusCode }
    ... on NotFound { __typename message statusCode }
  }
}
`;

export const getModuleHistory = /* GraphQL */ `
query GetModuleHistory(
  $projectId: Int!
  $serialNumber: String!
  $moduleSerial: String!
  $from: AWSDateTime!
  $to: AWSDateTime!
  $limit: Int!
  $pageNumber: Int
) {
  getModuleHistory(
    projectId: $projectId
    serialNumber: $serialNumber
    moduleSerial: $moduleSerial
    from: $from
    to: $to
    limit: $limit
    pageNumber: $pageNumber
  ) {
    ... on GetModuleHistorySuccess {
      __typename
      result {
        items { id serial model device_serial fw hw sdk extra received_on_utc processed_on_utc }
        pageNumber pageSize totalRows totalPages isLast
      }
    }
    ... on BadRequest { __typename message statusCode }
    ... on Forbidden { __typename message statusCode }
    ... on InternalServerError { __typename message statusCode }
    ... on NotFound { __typename message statusCode }
  }
}
`;

export const getDeviceSnapHistory = /* GraphQL */ `
query GetDeviceSnapHistory(
  $projectId: Int!
  $serialNumber: String!
  $from: AWSDateTime!
  $to: AWSDateTime!
  $limit: Int!
  $pageNumber: Int
) {
  getDeviceSnapHistory(
    projectId: $projectId
    serialNumber: $serialNumber
    from: $from
    to: $to
    limit: $limit
    pageNumber: $pageNumber
  ) {
    ... on GetDeviceSnapHistorySuccess {
      __typename
      result {
        items { id serial settings received_on_utc processed_on_utc }
        pageNumber pageSize totalRows totalPages isLast
      }
    }
    ... on BadRequest { __typename message statusCode }
    ... on Forbidden { __typename message statusCode }
    ... on InternalServerError { __typename message statusCode }
    ... on NotFound { __typename message statusCode }
  }
}
`;

export const getModuleSnapHistory = /* GraphQL */ `
query GetModuleSnapHistory(
  $projectId: Int!
  $serialNumber: String!
  $moduleSerial: String!
  $from: AWSDateTime!
  $to: AWSDateTime!
  $limit: Int!
  $pageNumber: Int
) {
  getModuleSnapHistory(
    projectId: $projectId
    serialNumber: $serialNumber
    moduleSerial: $moduleSerial
    from: $from
    to: $to
    limit: $limit
    pageNumber: $pageNumber
  ) {
    ... on GetModuleSnapHistorySuccess {
      __typename
      result {
        items { id serial device_serial settings received_on_utc processed_on_utc }
        pageNumber pageSize totalRows totalPages isLast
      }
    }
    ... on BadRequest { __typename message statusCode }
    ... on Forbidden { __typename message statusCode }
    ... on InternalServerError { __typename message statusCode }
    ... on NotFound { __typename message statusCode }
  }
}
`;

export const getShadowState = /* GraphQL */ `
query GetShadowState($projectId: Int!, $serialNumber: String!) {
  getShadowState(projectId: $projectId, serialNumber: $serialNumber) {
    ... on GetShadowStateSuccess {
      __typename
      result {
        lastDesiredUpdate
        lastReportedUpdate
        sync
        reported
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getNewUsersBetweenDates = /* GraphQL */ `
query GetNewUsersBetweenDates($from: AWSDateTime, $to: AWSDateTime) {
getNewUsersBetweenDates(from: $from, to: $to) {
    ... on GetNewUsersBetweenDatesSuccess {
      __typename
      result {
        username
        email
        createdDate
        groups
      }
    }
    ... on BadRequest {
      __typename
      message
      statusCode
    }
    ... on InternalServerError {
      __typename
      message
      statusCode
    }
    ... on NotFound {
      __typename
      message
      statusCode
    }
    ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createDevicePermission = /* GraphQL */ `
  mutation CreateDevicePermission($projectId: Int!, $device: String!) {
  createDevicePermission(projectId: $projectId, device: $device) {
      ... on CreateDevicePermissionSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteDevicePermission = /* GraphQL */ `
  mutation DeleteDevicePermission($projectId: Int!, $device: String!) {
  deleteDevicePermission(projectId: $projectId, device: $device) {
      ... on DeleteDevicePermissionSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const deleteAllDevicesPermissions = /* GraphQL */ `
  mutation DeleteAllDevicesPermissions($projectId: Int!) {
  deleteAllDevicesPermissions(projectId: $projectId) {
      ... on DeleteAllDevicesPermissionsSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getCongitoUsersPaginated = /* GraphQL */ `
query GetCognitoUsersPaginated(
  $paginationToken: String,
  $pageSize: Int!
) {
  getCognitoUsersPaginated(
    paginationToken: $paginationToken,
    pageSize: $pageSize
  ) {
      ... on GetCognitoUsersPaginatedSuccess {
      __typename
      data {
        username
        email
        createdDate
        groups
        lastLoginDate
      }
      paginationToken
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const createNewCredential = /* GraphQL */ `
  mutation CreateNewCredential(
    $projects: [String!]!
    $name: String!
    $quota: String!
    $alertThreshold: String!
    $iPWhiteList: [String]
    $pointOfContact: String
    $description: String
    $templateIds: [String!]!
  ) {
    createNewCredential(
      projects: $projects
      name: $name
      quota: $quota
      alertThreshold: $alertThreshold
      iPWhiteList: $iPWhiteList
      pointOfContact: $pointOfContact
      description: $description
      templateIds: $templateIds
    ) {
      __typename
      ... on CreateNewCredentialSuccess {
        result {
          id
          name
          accessKey
          secretAccessKey
        }
      }
      ... on BadRequest {
           __typename
      message
      statusCode
    }
      ... on InternalServerError {
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      message
      statusCode
    }
  }
}
`;

export const getTemplates = /* GraphQL */ `
  query GetTemplates {
    getTemplates {
      __typename
      ... on GetTemplatesSuccess {
        result {
          templateId
          services
          description
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getDeviceInfo = /* GraphQL */ `
  query GetDeviceInfo($projectId: Int!, $serialNumber: String!) {
  getDeviceInfo(projectId: $projectId, serialNumber: $serialNumber) {
      ... on GetDeviceInfoSuccess {
      __typename
        result {
        serial
        model
        country_code
        fw
        hw
        sdk
        extra
        extrasHasInfo
        timezone
        received_first_on_utc
        received_on_utc
        processed_on_utc
        device_snap
        device_gateway
        hasDeviceGatewayInfo
        modules
        hasModulesInfo
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;

export const getCandidates = /* GraphQL */ `
  query GetCandidates(
    $projectId: Int!, 
    $fileId: String,
    $releaseID: String,
    $fileIDs: [String],
    $targetMarket: [String],
    $excludeMarket: [String],
    $target: String,
    $targets: [String],
    $exclude: [String],
    $targetRegex: [String],
    $excludeRegex: [String]
  ) {
  getCandidates(
    projectId: $projectId, 
    fileId: $fileId,
    releaseID: $releaseID,
    fileIDs: $fileIDs,
    targetMarket: $targetMarket,
    excludeMarket: $excludeMarket,
    target: $target,
    targets: $targets,
    exclude: $exclude,
    targetRegex: $targetRegex,
    excludeRegex: $excludeRegex
  ) {
      ... on GetCandidatesSuccess {
      __typename
        result {
        count
      }
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
    }
  }
}
`;

export const createAuditLog = /* GraphQL */ `
  mutation CreateAuditLog(
    $entity: String!
    $entity_id: String
    $change: String!
    $detail: String
    $value: String
    $user_id: String!
    $user_name: String!
  ) {
  createAuditLog(
    entity: $entity
      entity_id: $entity_id
      change: $change
      detail: $detail
      value: $value
      user_id: $user_id
      user_name: $user_name
  ) {
      ... on CreateAuditLogSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
  }
}
`;

export const updateLogicalUser = /* GraphQL */ `
  mutation UpdateLogicalUser(
  $userName: String!,
  $userId: String!,
  $physicalUserId: String!,
  $iPWhiteList: [String],
  $pointOfContact: String,
  $description: String,
  $alertThreshold: Int,
  $brands: [Int]
) {
  updateLogicalUser(
    userName: $userName,
    userId: $userId,
    physicalUserId: $physicalUserId,
    iPWhiteList: $iPWhiteList,
    pointOfContact: $pointOfContact,
    description: $description,
    alertThreshold: $alertThreshold,
    brands: $brands,
  ) {
      ... on UpdateLogicalUserSuccess {
      __typename
      result
      changeIds
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
    }
  }
}
`;

// Feature 032 - update a logical user's GPG public key
export const updateLogicalUserGpgKey = /* GraphQL */ `
  mutation UpdateLogicalUserGpgKey($userName: String!, $publicKey: String!) {
    updateLogicalUserGpgKey(userName: $userName, publicKey: $publicKey) {
      ... on UpdateLogicalUserGpgKeySuccess {
        __typename
        result
        changeIds
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

// Feature 032 - rotate all physical users linked to a logical user
export const rotateLinkedCredentials = /* GraphQL */ `
  mutation RotateLinkedCredentials($physicalUserIds: [String!]!) {
    rotateLinkedCredentials(physicalUserIds: $physicalUserIds) {
      ... on RotateLinkedCredentialsSuccess {
        __typename
        results {
          physicalUserId
          success
          message
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const updateCertificateQuota = /* GraphQL */ `
  mutation UpdateCertificateQuota($awsUserId: String!, $amount: Int!, $threshold: Int!) {
  updateCertificateQuota(awsUserId: $awsUserId, amount: $amount, threshold: $threshold) {
      ... on UpdateCertificateQuotaSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
    }
      ... on NotFound {
      __typename
      message
      statusCode
    }
  }
}
`;


export const disablePhysicalUser = /* GraphQL */ `
  mutation DisablePhysicalUser($userId: String!) {
  disablePhysicalUser(userId: $userId) {
      ... on DisablePhysicalUserSuccess {
      __typename
      result
    }
      ... on BadRequest {
      __typename
      message
      statusCode
    }
      ... on InternalServerError {
      __typename
      message
      statusCode
    }
      ... on Forbidden {
      __typename
      message
      statusCode
    }
  }
}
`;

export const enablePhysicalUser = /* GraphQL */ `
  mutation EnablePhysicalUser($userId: String!) {
    enablePhysicalUser(userId: $userId) {
      __typename
      ... on EnablePhysicalUserSuccess {
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getPhysicalUserTemplates = /* GraphQL */ `
  query GetPhysicalUserTemplates($physicalUserId: String!) {
    getPhysicalUserTemplates(physicalUserId: $physicalUserId) {
      __typename
      ... on GetPhysicalUserTemplatesSuccess {
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const getChangeRequestStatus = /* GraphQL */ `
  query GetChangeRequestStatus($changeId: String!) {
    getChangeRequestStatus(changeId: $changeId) {
      __typename
      ... on GetChangeRequestStatusSuccess {
        changeId
        status
        action
        createdOn
        updatedOn
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

const POLICY_TEMPLATE_FIELDS = `
  templateId
  description
  services
  readOnly
  permission {
    actions
    resources {
      resource
      service
    }
  }
`;

const ERROR_FRAGMENTS = `
  ... on BadRequest {
    __typename
    message
    statusCode
  }
  ... on InternalServerError {
    __typename
    message
    statusCode
  }
  ... on NotFound {
    __typename
    message
    statusCode
  }
  ... on Forbidden {
    __typename
    message
    statusCode
  }
`;

export const getPolicyTemplateDetails = /* GraphQL */ `
  query GetPolicyTemplateDetails($templateId: String!) {
    getPolicyTemplateDetails(templateId: $templateId) {
      __typename
      ... on GetPolicyTemplateDetailsSuccess {
        result {
          ${POLICY_TEMPLATE_FIELDS}
        }
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const createPolicyTemplate = /* GraphQL */ `
  mutation CreatePolicyTemplate($description: String!, $services: [String]!, $readOnly: Boolean, $permission: [PolicyPermissionInput]!) {
    createPolicyTemplate(description: $description, services: $services, readOnly: $readOnly, permission: $permission) {
      __typename
      ... on CreatePolicyTemplateSuccess {
        result {
          ${POLICY_TEMPLATE_FIELDS}
        }
        changeIds
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const updatePolicyTemplate = /* GraphQL */ `
  mutation UpdatePolicyTemplate($templateId: String!, $description: String!, $services: [String]!, $readOnly: Boolean, $permission: [PolicyPermissionInput]!) {
    updatePolicyTemplate(templateId: $templateId, description: $description, services: $services, readOnly: $readOnly, permission: $permission) {
      __typename
      ... on UpdatePolicyTemplateSuccess {
        result {
          ${POLICY_TEMPLATE_FIELDS}
        }
        changeIds
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const deletePolicyTemplate = /* GraphQL */ `
  mutation DeletePolicyTemplate($templateId: String!) {
    deletePolicyTemplate(templateId: $templateId) {
      __typename
      ... on DeletePolicyTemplateSuccess {
        result
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const listVariables = /* GraphQL */ `
  query ListVariables {
    listVariables {
      __typename
      ... on ListVariablesSuccess {
        result {
          environment
          region
          name
          value
          createdBy
          updatedOn
        }
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const createVariable = /* GraphQL */ `
  mutation CreateVariable($name: String!, $value: String!) {
    createVariable(name: $name, value: $value) {
      __typename
      ... on CreateVariableSuccess {
        result {
          environment
          region
          name
          value
          createdBy
          updatedOn
        }
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const updateVariable = /* GraphQL */ `
  mutation UpdateVariable($name: String!, $value: String!) {
    updateVariable(name: $name, value: $value) {
      __typename
      ... on UpdateVariableSuccess {
        result {
          environment
          region
          name
          value
          createdBy
          updatedOn
        }
        changeIds
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const deleteVariable = /* GraphQL */ `
  mutation DeleteVariable($name: String!) {
    deleteVariable(name: $name) {
      __typename
      ... on DeleteVariableSuccess {
        result
      }
      ${ERROR_FRAGMENTS}
    }
  }
`;

export const attachTemplateToPhysicalUser = /* GraphQL */ `
  mutation AttachTemplateToPhysicalUser($physicalUserId: String!, $templateId: String!) {
    attachTemplateToPhysicalUser(physicalUserId: $physicalUserId, templateId: $templateId) {
      __typename
      ... on AttachTemplateSuccess {
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const detachTemplateFromPhysicalUser = /* GraphQL */ `
  mutation DetachTemplateFromPhysicalUser($physicalUserId: String!, $templateId: String!) {
    detachTemplateFromPhysicalUser(physicalUserId: $physicalUserId, templateId: $templateId) {
      __typename
      ... on DetachTemplateSuccess {
        result
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const deleteAccessKeys = /* GraphQL */ `
  mutation DeleteAccessKeys($physicalUserId: String!, $accessKeyId: String) {
    deleteAccessKeys(physicalUserId: $physicalUserId, accessKeyId: $accessKeyId) {
      ... on DeleteAccessKeysSuccess {
        __typename
        success
        message
        userId
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const deletePhysicalUserMutation = /* GraphQL */ `
  mutation DeletePhysicalUser($physicalUserId: String!) {
    deletePhysicalUser(physicalUserId: $physicalUserId) {
      ... on DeletePhysicalUserSuccess {
        __typename
        success
        message
        deletedUserId
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const rotateCredential = /* GraphQL */ `
  mutation RotateCredential($physicalUserId: String!) {
    rotateCredential(physicalUserId: $physicalUserId) {
      __typename
      ... on RotateCredentialSuccess {
        result {
          id
          accessKey
          secretAccessKey
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
    }
  }
`;

// RUBIQ AGENT QUERIES AND MUTATIONS_________________________

export const triggerRubiqAgent = /* GraphQL */ `
  mutation TriggerRubiqAgent(
    $projectId: Int!, 
    $conversationId: String!, 
    $query: String!, 
    $routeId: String,
    $routeName: String,
    $socketId: String!,
    $jwtToken: String!,
    $useStreaming: Boolean) {
    triggerRubiqAgent(
      projectId: $projectId,
      conversationId: $conversationId,
      query: $query,
      routeId: $routeId,
      routeName: $routeName,
      socketId: $socketId,
      jwtToken: $jwtToken,
      useStreaming: $useStreaming
    ) {
      ... on TriggerRubiqAgentSuccess {
        __typename
        success
        result {
          socketId
          processedResponse
          notTranslatedResponse
          rawResponse
          referenceList {
            id
            title
            content
            url
            distance
          }
          notTranslatedReferenceList {
            id
            title
            content
            url
            distance
          }
          status
          agentId
          action
          actionDefinition
          conversationStarters
          followUpQuestions
          timestamp
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const fetchDeviceKnowledge = /* GraphQL */ `
  mutation FetchDeviceKnowledge($brand: String!, $routeId: String!) {
    fetchDeviceKnowledge(brand: $brand, routeId: $routeId) {
      ... on FetchDeviceKnowledgeSuccess {
        __typename
        id
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const onRubiqAgentQueryResponse = /* GraphQL */ `
  subscription OnRubiqAgentQueryResponse($socketId: String!) {
    onRubiqAgentQueryResponse(socketId: $socketId) {
      ... on PublishRubiqAgentResponseSuccess {
        __typename
        success
        result {
          socketId
          processedResponse
          notTranslatedResponse
          rawResponse
          referenceList {
            id
            title
            content
            url
            distance
          }
          notTranslatedReferenceList {
            id
            title
            content
            url
            distance
          }
          status
          agentId
          action
          actionDefinition
          conversationStarters
          followUpQuestions
          timestamp
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on NotFound {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
        statusCode
      }
    }
  }
`;

// Data Dictionary Queries
export const exportRecipes = /* GraphQL */ `
  query ExportRecipes($projectId: Int!) {
    exportRecipes(projectId: $projectId) {
      ... on ExportRecipesSuccess {
        __typename
        s3_presigned_url
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const exportEvents = /* GraphQL */ `
  query ExportEvents($projectId: Int!) {
    exportEvents(projectId: $projectId) {
      ... on ExportEventsSuccess {
        __typename
        s3_presigned_url
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const exportSubevents = /* GraphQL */ `
  query ExportSubevents($projectId: Int!) {
    exportSubevents(projectId: $projectId) {
      ... on ExportSubeventsSuccess {
        __typename
        s3_presigned_url
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const exportProducts = /* GraphQL */ `
  query ExportProducts($projectId: Int!) {
    exportProducts(projectId: $projectId) {
      ... on ExportProductsSuccess {
        __typename
        s3_presigned_url
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
    }
  }
`;

export const importRecipes = /* GraphQL */ `
  mutation ImportRecipes($projectId: Int!, $file: String!) {
    importRecipes(projectId: $projectId, file: $file) {
      ... on ImportRecipesSuccess {
        __typename
        success
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
        details
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
        details
      }
      ... on NotFound {
        __typename
        message
        details
      }
      ... on Forbidden {
        __typename
        message
        details
      }
    }
  }
`;

export const importEvents = /* GraphQL */ `
  mutation ImportEvents($projectId: Int!, $file: String!) {
    importEvents(projectId: $projectId, file: $file) {
      ... on ImportEventsSuccess {
        __typename
        success
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
        details
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
        details
      }
      ... on NotFound {
        __typename
        message
        details
      }
      ... on Forbidden {
        __typename
        message
        details
      }
    }
  }
`;

export const importSubevents = /* GraphQL */ `
  mutation ImportSubevents($projectId: Int!, $file: String!) {
    importSubevents(projectId: $projectId, file: $file) {
      ... on ImportSubeventsSuccess {
        __typename
        success
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
        details
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
        details
      }
      ... on NotFound {
        __typename
        message
        details
      }
      ... on Forbidden {
        __typename
        message
        details
      }
    }
  }
`;

export const importProducts = /* GraphQL */ `
  mutation ImportProducts($projectId: Int!, $file: String!) {
    importProducts(projectId: $projectId, file: $file) {
      ... on ImportProductsSuccess {
        __typename
        success
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
        details
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
        details
      }
      ... on NotFound {
        __typename
        message
        details
      }
      ... on Forbidden {
        __typename
        message
        details
      }
    }
  }
`;

export const generateReleaseCandidate = /* GraphQL */ `
  mutation GenerateReleaseCandidate($projectId: Int!) {
    generateReleaseCandidate(projectId: $projectId) {
      ... on GenerateReleaseCandidateSuccess {
        __typename
        success
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const getReleases = /* GraphQL */ `
  query GetReleases($projectId: Int!) {
    getReleases(projectId: $projectId) {
      ... on GetReleasesSuccess {
        __typename
        releases {
          version
          last_modified
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const deployReleaseCandidate = /* GraphQL */ `
  mutation DeployReleaseCandidate($projectId: Int!) {
    deployReleaseCandidate(projectId: $projectId) {
      ... on DeployReleaseCandidateSuccess {
        __typename
        message
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const getDeviceQuarantineStatus = /* GraphQL */ `
  query GetDeviceQuarantineStatus($projectId: Int!, $deviceSerial: String!) {
    getDeviceQuarantineStatus(projectId: $projectId, deviceSerial: $deviceSerial) {
      ... on DeviceQuarantineStatusSuccess {
        __typename
        data {
          deviceSerial
          blocked
          insertedOn
          releasedOn
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const blockDevice = /* GraphQL */ `
  mutation BlockDevice($projectId: Int!, $deviceSerial: String!) {
    blockDevice(projectId: $projectId, deviceSerial: $deviceSerial) {
      ... on DeviceQuarantineStatusSuccess {
        __typename
        data {
          deviceSerial
          blocked
          insertedOn
          releasedOn
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;

export const releaseDevice = /* GraphQL */ `
  mutation ReleaseDevice($projectId: Int!, $deviceSerial: String!) {
    releaseDevice(projectId: $projectId, deviceSerial: $deviceSerial) {
      ... on DeviceQuarantineStatusSuccess {
        __typename
        data {
          deviceSerial
          blocked
          insertedOn
          releasedOn
        }
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;


export const estimateExportDuration = /* GraphQL */ `
  query EstimateExportDuration(
    $projectId: Int!
    $action: String!
    $dateIni: AWSDateTime!
    $dateEnd: AWSDateTime!
    $filters: String
    $serialNumber: String
    $object: String
    $queryParams: String
    $totalRows: Int
  ) {
    estimateExportDuration(
      projectId: $projectId
      action: $action
      dateIni: $dateIni
      dateEnd: $dateEnd
      filters: $filters
      serialNumber: $serialNumber
      object: $object
      queryParams: $queryParams
      totalRows: $totalRows
    ) {
      ... on EstimateExportDurationSuccess {
        __typename
        action
        estimatedSeconds
        willExceedLimit
        limitSeconds
      }
      ... on BadRequest {
        __typename
        message
        statusCode
      }
      ... on InternalServerError {
        __typename
        message
        statusCode
      }
      ... on Forbidden {
        __typename
        message
      }
      ... on NotFound {
        __typename
        message
      }
    }
  }
`;
